const footLinks = [
  { key: 'fresh', label: '今日新料' },
  { key: 'heat', label: '热度飙升榜' },
  { key: 'topic', label: '瓜棚追更' },
  { key: 'pending', label: '待爆预警' },
];

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-12 md:py-14">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-background-50/10">
                <i className="ri-news-line text-lg text-accent-300" />
              </span>
              <span className="font-heading text-xl font-bold">黑吃瓜</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-primary-100/80">
              每日黑料速递，今日新料与猛料按圈子持续上新。
              进来挑一块瓜田，慢慢吃、追更不迷路。
            </p>
          </div>

          <nav className="grid grid-cols-2 gap-x-10 gap-y-3 sm:grid-cols-2">
            {footLinks.map((l) => (
              <a
                key={l.key}
                href={`#${l.key}`}
                className="flex items-center gap-2 text-sm text-primary-100/90 hover:text-background-50 cursor-pointer"
              >
                <i className="ri-arrow-right-s-line text-accent-400" />
                {l.label}
              </a>
            ))}
          </nav>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-white/10 pt-6 text-xs text-primary-100/70 sm:flex-row sm:items-center sm:justify-between">
          <span>© 2026 黑吃瓜 · 黑料速递</span>
          <span className="flex items-center gap-1.5">
            <i className="ri-file-shield-line" />
            内容为编辑演绎示例，仅作静态展示
          </span>
        </div>
      </div>
    </footer>
  );
}